<template>
  <v-card flat tile color="white">
    <v-container>

      <v-row class="text-center" justify="center">
        <v-card v-for="(src, i) in logos" :key="i" class="ma-3 pa-3" flat tile>
          <v-img :src="src" :lazy-src="src" min-width="100" max-width="100"></v-img>
        </v-card>
      </v-row>
      <v-row class="text-center" justify="center">
        <!-- <v-card class="pa-3" outlined tile>
          <v-img src="/img/developers.jpeg" lazy-src="/img/developers.jpeg" min-width="200" max-width="200"></v-img>
        </v-card> -->

        <v-col cols="12">
          <p class="overline">Oleh :</p>
          <p class="body-1 ma-0">Vika Annisa Qurrata</p>
          <!-- <p class="body-1 ma-0">Ermita Yusida</p>
          <p class="body-1 ma-0">Linda Seprillina</p>
          <p class="body-1 ma-0">Santi Merlinda</p> -->
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>
<script>
export default {
  data: () => ({
    logos: [
      '/img/um.jpeg'
      // '/img/isdb.jpeg'
    ]
  })
}
</script>
